import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../main/baseQueryWithReauth';
import { GetAttendeeEventsResponse, AttendeeEventsFilter } from './models';

const attendee_events = 'attendee_events';

export const attendeeEventsApi = createApi({
  reducerPath: attendee_events,
  baseQuery: baseQueryWithReauth,
  tagTypes: [attendee_events],
  endpoints: (build) => ({
    getAttendeeEvents: build.query<GetAttendeeEventsResponse, AttendeeEventsFilter>({
      query: (filters) => {
        const params = new URLSearchParams();

        if (filters?.search && filters.search.length > 2) {
          params.append('filters[search]', filters.search);
        }

        if (filters?.page) {
          params.append('page', filters.page.toString());
        }

        const queryString = params.toString();

        return {
          url: `/attendee/events${queryString ? '?' + queryString : ''}`,
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        };
      },
      providesTags: [{ type: attendee_events, id: 'LIST' }],
    }),
  }),
});

export const { useGetAttendeeEventsQuery } = attendeeEventsApi;
